module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDxzeW1ib2wgaWQ9ImVsbGlwc2UiIG92ZXJmbG93PSJ2aXNpYmxlIgoJCXByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHZpZXdCb3g9IjAgMCAxMDAgNTAiPgoJPGRlc2M+ZWxsaXBzZTwvZGVzYz4KCTxlbGxpcHNlIHN0cm9rZT0iY3VycmVudENvbG9yIiBjeD0iNTAiIGN5PSIyNSIgcng9IjUwIiByeT0iMjUiPjwvZWxsaXBzZT4KICAgIDwvc3ltYm9sPgogIDwvZGVmcz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/ellipse.svg
// module id = 698
// module chunks = 0